/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Error_Send_FailedInputs */

const tr_contact_form_error_send_failed = /** @type {(inputs: Contact_Form_Error_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönderilemedi. Lütfen tekrar dene.`)
};

const en_contact_form_error_send_failed = /** @type {(inputs: Contact_Form_Error_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message could not be sent. Please try again.`)
};

const de_contact_form_error_send_failed = /** @type {(inputs: Contact_Form_Error_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.`)
};

const ru_contact_form_error_send_failed = /** @type {(inputs: Contact_Form_Error_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.`)
};

/**
* | output |
* | --- |
* | "Message could not be sent. Please try again." |
*
* @param {Contact_Form_Error_Send_FailedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_error_send_failed = /** @type {((inputs?: Contact_Form_Error_Send_FailedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Error_Send_FailedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_error_send_failed(inputs)
	if (locale === "de") return de_contact_form_error_send_failed(inputs)
	if (locale === "ru") return ru_contact_form_error_send_failed(inputs)
	return tr_contact_form_error_send_failed(inputs)
});